import React from 'react';
import { cn } from './cn';

/**
 * Solid surface card. `interactive` adds hover/active affordances for tappable cards.
 */
const Card = React.forwardRef(function Card(
  { as: Tag = 'div', interactive = false, padded = true, className, children, ...rest },
  ref
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        'bg-card border border-line rounded-card shadow-card',
        padded && 'p-4',
        interactive &&
          'transition-[border-color,transform,box-shadow] duration-150 hover:border-line-strong active:scale-[0.995] cursor-pointer',
        className
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export const CardSection = ({ title, action, className, children }) => (
  <section className={cn('bg-card border border-line rounded-card p-4', className)}>
    {(title || action) && (
      <header className="flex items-center justify-between mb-3">
        {title && <h3 className="text-sm font-semibold text-primary">{title}</h3>}
        {action}
      </header>
    )}
    {children}
  </section>
);

export default Card;
